import { render, staticRenderFns } from "./ExcelTemplateBasedReportDetails.vue?vue&type=template&id=109c2270"
import script from "./ExcelTemplateBasedReportDetails.vue?vue&type=script&lang=js"
export * from "./ExcelTemplateBasedReportDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports